import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface Shortcut {
  key: string // KeyboardEvent.key.toLowerCase()
  path: string
  adminOnly?: boolean
}

// ВАЖНО: держать в паре с NAV_ITEMS (nav-items.tsx) — списки независимы намеренно.
const ROUTE_SHORTCUTS: Shortcut[] = [
  { key: 'p', path: '/profile' },
  { key: 'v', path: '/vpn' },
  { key: 'b', path: '/security' },
  // Приглашения живут разделом на /admin/users — отдельного шортката у них нет.
  { key: 'u', path: '/admin/users', adminOnly: true },
  { key: 'g', path: '/admin/groups', adminOnly: true },
  { key: 'o', path: '/admin/outbounds', adminOnly: true },
]

// true если фокус в поле ввода — тогда шорткаты не трогаем.
function isTypingInForm(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  const tag = target.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (target.isContentEditable) return true
  return false
}

export function useKeyboardShortcuts(isAdmin: boolean): void {
  const navigate = useNavigate()
  useEffect(() => {
    function handler(event: KeyboardEvent) {
      if (event.metaKey || event.ctrlKey || event.altKey) return
      if (isTypingInForm(event.target)) return
      const key = event.key.toLowerCase()
      const shortcut = ROUTE_SHORTCUTS.find((s) => s.key === key)
      if (!shortcut) return
      if (shortcut.adminOnly && !isAdmin) return
      event.preventDefault()
      void navigate(shortcut.path)
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [navigate, isAdmin])
}
